/*
 * Copyright (c) 2022.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import PerfectScrollbar from "perfect-scrollbar";
import Headroom from "headroom.js";
import {is_breakpoint_up} from "../helpers/functions";
import Hammer from 'hammerjs';

$(function(){
    function initRelation(){
        let $relations = $('.relations-component');
        if($relations.data('init')){
            return;
        }

        $relations.data('init', true);

        $relations.find('[data-relations-back]').off('click').on('click', function (e){
            e.preventDefault();

            $relations.trigger('relations.close');
        });

        $relations.find('[data-relations-close]').off('click').on('click', function (e){
            e.preventDefault();

            $relations.trigger('relations.doAction');
        });

        $relations.find('[data-relations-video]').off('canplay').on('canplay', function (e){
            $relations.find('[data-relations-loader]').hide();
        });

        $relations.find('[data-relations-video]').off('ended').on('ended', function (e){
            $relations.trigger('relations.endSlide');
        });

        $relations.find('[data-relations-action]').off('click').on('click', function (e){
            let options = $relations.data('options');
            if(typeof options.trigger === 'undefined'){
                return;
            }

            $relations.trigger('relations.close');

            options.trigger[0].click();
        });

        $relations.find('[data-relations-navigation-prev]').off('click').on('click', function (e){
            let slideNumber = $relations.data('slideNumber');
            if(slideNumber<1){
                return;
            }

            $relations.trigger('relations.setSlide', slideNumber-1);
        });

        $relations.find('[data-relations-navigation-next]').off('click').on('click', function (e){
            let options = $relations.data('options');
            let slideNumber = $relations.data('slideNumber');
            if(slideNumber >= options.slides.length){
                return;
            }

            if(options.slides.length-1 === slideNumber){
                $relations.trigger('relations.endSlide');
            }else{
                $relations.trigger('relations.setSlide', slideNumber+1);
            }
        });

        let mc = new Hammer.Manager($relations.get(0));
        mc.add( new Hammer.Swipe({ direction: Hammer.DIRECTION_DOWN }) );
        mc.on("swipedown", function(ev) {
            $relations.trigger('relations.close');
        });

        $relations.on('relations.doAction', function (e){
            $relations.find('[data-relations-action]').get(0).click();
        });

        $relations.on('relations.endSlide', function (e){
            let options = $relations.data('options');
            let slideNumber = $relations.data('slideNumber');

            if(options.slides.length-1 === slideNumber){
                $relations.trigger('relations.doAction');
            }else{
                $relations.trigger('relations.setSlide', slideNumber+1);
            }
        });

        $relations.on('relations.setSlide', function (e, slideNumber){
            let options = $relations.data('options');
            if(typeof options.slides[slideNumber] === 'undefined'){
                return;
            }

            $relations.data('slideNumber', slideNumber);

            $relations.find('[data-relations-loader]').show();
            $relations.find('[data-relations-video]').attr('src', options.slides[slideNumber]);
            $relations.find('[data-relations-video]').show();
            $relations.find('[data-relations-navigation] .relations-navigation__slide').removeClass('active');
            $relations.find('[data-relations-navigation] .relations-navigation__slide').eq(slideNumber).addClass('active');

            $relations.find('[data-relations-video]')[0].currentTime = 0;
            try{
                $relations.find('[data-relations-video]')[0].play();
            }catch (e){}
        });

        $relations.on('relations.open', function (e, options){
            $relations.data('options', options);
            $relations.find('[data-relations-icon]').html(options.icon ?? '');
            $relations.find('[data-relations-name]').html(options.name ?? '');
            $relations.find('[data-relations-loader]').show();
            $relations.find('[data-relations-video]').hide();
            $relations.find('[data-relations-navigation]').html('<div class="relations-navigation__slide"></div>'.repeat(options.slides.length));

            $('html').addClass('relations-opened');
            setTimeout(function (){
                $relations.addClass('show');
                $relations.trigger('relations.setSlide', [0]);
            }, 100);
        });

        $relations.on('relations.close', function (e){
            $relations.removeClass('show');
            setTimeout(function (){
                $('html').removeClass('relations-opened');
            }, 500);

            try{
                $relations.find('[data-relations-video]')[0].pause();
            }catch (e){}

            $relations.find('[data-relations-video]').removeAttr('src');
        });
    }

    function initIconsMenu() {
        let $widget = $('.icons-menu-widget');
        if(!$widget.length){
            return;
        }

        $widget.each(function(){
            new PerfectScrollbar($(this).get(0), {
                useBothWheelAxes: true,
                suppressScrollY: true,
            });
        });

        $widget.on('click', '[data-relation]', function (e){
            let slides = $(this).data('relation');
            if(
                !slides
                || is_breakpoint_up('lg')
            ){
                return;
            }

            initRelation();

            $('.relations-component').trigger('relations.open', [{
                trigger: $(this).clone(),
                name: $(this).find('.title').html(),
                icon: $(this).find('.image').html(),
                slides: slides,
            }]);

            e.preventDefault();
        });
    }

    initIconsMenu();

    function initIconsMenuSlide(){
        let $widget = $('.icons-menu-slide-container');
        if(!$widget.length){
            return;
        }

        let options = $widget.data('menu-options');
        options.headroom = $.extend({}, {
            tolerance: {
                up: 20,
                down: 0
            }
        }, options.headroom);

        let headroom  = new Headroom($widget.get(0), options.headroom ?? {});
        headroom.init();
    }

    initIconsMenuSlide();
});
